<script lang="ts">
	interface Props {
		strokeColor?: string
	}

	let { strokeColor = "black" }: Props = $props()
</script>

<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M13 20C12.0974 20 10.9609 20 9.99962 20C8.89505 20 8 19.1046 8 18V9C8 7.89543 8.89543 7 10 7H39C40.1046 7 41 7.89543 41 9V18C41 19.1046 40.1046 20 39 20H36"
		stroke={strokeColor}
		stroke-width="3"
		stroke-linecap="round"
		class="svg-stroke"
	/>
	<circle cx="33.5" cy="13.5" r="3.5" fill={strokeColor} class="svg-fill" />
	<path
		d="M13 41C12.0974 41 10.9609 41 9.99962 41C8.89505 41 8 40.1046 8 39V30C8 28.8954 8.89543 28 10 28H39C40.1046 28 41 28.8954 41 30V39C41 40.1046 40.1046 41 39 41H36"
		stroke={strokeColor}
		stroke-width="3"
		stroke-linecap="round"
		class="svg-stroke"
	/>
	<circle cx="33.5" cy="34.5" r="3.5" fill={strokeColor} class="svg-fill" />
</svg>

<style>
</style>
